import newsService from '@/services/news'

export default {
  getData ({commit}, params = {}) {
    return new Promise((resolve, reject) => {
      newsService.getData({
        params,
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          const data = response.data.data
          commit('SET_DATA', data)
          resolve(data)
        })
    })
  }
}